var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-icon/u-icon" */ "@/uni_modules/uview-ui/components/u-icon/u-icon.vue"
      )
    },
    "u-Text": function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u--text/u--text" */ "@/uni_modules/uview-ui/components/u--text/u--text.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([
    {
      backgroundColor:
        _vm.text || _vm.icon
          ? _vm.randomBgColor
            ? _vm.colors[
                _vm.colorIndex !== "" ? _vm.colorIndex : _vm.$u.random(0, 19)
              ]
            : _vm.bgColor
          : "transparent",
      width: _vm.$u.addUnit(_vm.size),
      height: _vm.$u.addUnit(_vm.size),
    },
    _vm.$u.addStyle(_vm.customStyle),
  ])
  var g0 = _vm.mpAvatar && _vm.allowMp ? _vm.$u.addUnit(_vm.size) : null
  var g1 = _vm.mpAvatar && _vm.allowMp ? _vm.$u.addUnit(_vm.size) : null
  var g2 =
    !(_vm.mpAvatar && _vm.allowMp) && !_vm.icon && !_vm.text
      ? _vm.$u.addUnit(_vm.size)
      : null
  var g3 =
    !(_vm.mpAvatar && _vm.allowMp) && !_vm.icon && !_vm.text
      ? _vm.$u.addUnit(_vm.size)
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }